﻿import { memo } from 'react';
import { Box, Typography, alpha } from '@mui/material';
import { designTokens } from '@design-system';

import Navigation from './Navigation';
import CopyRight from './CopyRight';

const DrawerContent = memo(function DrawerContent() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      {/* Section Label */}
      <Box sx={{ px: 2.5, pt: 1.5, pb: 1 }}>
        <Typography
          sx={{
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: designTokens.colors.neutral[500],
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            fontFamily: 'inherit',
          }}
        >
          Main Menu
        </Typography>
      </Box>

      {/* Navigation Menu */}
      {/* Navigation keeps its search box fixed and scrolls only the menu list */}
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          px: 0.75,
          '& *::-webkit-scrollbar': {
            width: '4px',
          },
          '& *::-webkit-scrollbar-track': {
            background: 'transparent',
          },
          '& *::-webkit-scrollbar-thumb': {
            background: alpha(designTokens.colors.neutral[500], 0.3),
            borderRadius: '4px',
          },
          '& *::-webkit-scrollbar-thumb:hover': {
            background: alpha(designTokens.colors.neutral[500], 0.5),
          },
        }}
      >
        <Navigation />
      </Box>

      {/* Copyright Footer */}
      <Box
        sx={{
          p: 1.5,
          borderTop: `1px solid ${alpha(designTokens.colors.neutral[500], 0.1)}`,
        }}
      >
        <CopyRight />
      </Box>
    </Box>
  );
});

DrawerContent.displayName = 'DrawerContent';

export default DrawerContent;
